const BaseService = require('@/services/BaseService')

const namespace = 'contacts'

const find = (id, options, cb, errorCb) => {
  BaseService.get(namespace + '/' + id, options, cb, errorCb)
}

const findAll = (options, cb, errorCb) => {
  BaseService.get(namespace, options, cb, errorCb)
}

const count = (options, cb, errorCb) => {
  BaseService.get(namespace + '/count', options, cb, errorCb)
}

export {
  find,
  findAll,
  count
}
